import { appConfig } from '../assets/customizations/config'

const baseProviderResources = [
    {
        fhirResource: 'Endpoint',
        label: 'Endpoint',
    },
    {
        fhirResource: 'Organization',
        label: 'Organization',
        filter: 'Name'
    },
    {
        fhirResource: 'OrganizationAffiliation',
        label: 'OrganizationAffiliation',
        filter: 'Name'
    },

    {
        fhirResource: 'Practitioner',
        label: 'Practitioner',
        filter: 'Name'
    },
    {
        fhirResource: 'PractitionerRole',
        label: 'PractitionerRole',
        filter: 'Name'
    },
    {
        fhirResource: 'HealthcareService',
        label: 'HealthcareService'
    },
    {
        fhirResource: 'InsurancePlan',
        label: 'InsurancePlan',
        // filter: 'Name'
    }, {
        fhirResource: 'Location',
        label: 'Location',
        filter: 'Name'
    },
    {
        fhirResource: 'Network',
        label: 'Network'
    }
]
const formularyResources = appConfig.use_formulary
    ? [
        { fhirResource: 'MedicationKnowledge', label: 'MedicationKnowledge' },
        { fhirResource: 'List', label: ' List (Formulary Coverage Plans)' },
    ]
    : []


export const providerResources: { fhirResource: string, label: string, filter?: string }[] = [...baseProviderResources, ...formularyResources]

export const alphabet = Array.from({ length: 26 }, (_, i) =>
    String.fromCharCode(65 + i)
)